import {
  SendContentType,
  WecomFileMessageType,
  WecomImageMessageType,
  WecomLinkMessageType,
  WecomMiniProgramMessageType,
  WecomMsgType,
  WecomVideoMessageType,
  WecomVideoNumMessageType,
} from "../../types";
import {
  WecomFileSendData,
  WecomGifSendData,
  WecomImageSendData,
  WecomLinkSendData,
  WecomMiniProgramSendData,
  WecomSendDataType,
  WecomVideoNumSendData,
  WecomVideoSendData,
} from "./send-message";

const baseMessage = {
  chat_id: "",
  another_id: "",
  conversation_id: "",
  msg_server_id: "",
  msg_unique_identifier: "",
  request_key: "",
  sender_id: "",
  timestamp: 0,
  from_user_id: "",
  invoke_msgtype: 0,
  invoke_msg_unique_identifier: "",
  robot_task_id: "",
};

export const convertSendDataToWecomMessage = (data: WecomSendDataType) => {
  const { type } = data;
  switch (type) {
    case SendContentType.IMAGE: {
      const send_data = data.send_data as WecomImageSendData;
      return {
        ...baseMessage,
        msgtype: WecomMsgType.WECOM_IMAGE,
        file_url: send_data?.path,
        file_name: send_data?.file_name,
      } as WecomImageMessageType;
    }
    case SendContentType.GIF: {
      const send_data = data.send_data as WecomGifSendData;
      return {
        ...baseMessage,
        msgtype: WecomMsgType.GIF,
        file_url: send_data?.path,
        file_name: send_data?.file_name,
      };
    }
    case SendContentType.VIDEO: {
      const send_data = data.send_data as WecomVideoSendData;
      return {
        ...baseMessage,
        msgtype: WecomMsgType.WECOM_VIDEO,
        file_url: send_data?.path,
        file_name: send_data?.file_name,
      } as WecomVideoMessageType;
    }
    case SendContentType.VIDEO_NUM: {
      const send_data = data.send_data as WecomVideoNumSendData;
      return {
        ...baseMessage,
        msgtype: WecomMsgType.VIDEO_NUM,
        channel_name: send_data.channel_name,
        channel_url: send_data?.channel_url,
        encode_data: send_data?.encode_data,
        head_img_url: send_data?.head_img_url,
        username: send_data?.username,
        thumburl: send_data?.thumb_url,
      } as WecomVideoNumMessageType;
    }
    case SendContentType.LINK: {
      const send_data = data.send_data as WecomLinkSendData;
      return {
        ...baseMessage,
        msgtype: WecomMsgType.LINK,
        title: send_data.title,
        desc: send_data?.desc,
        thumburl: send_data.thumburl,
        url: send_data.url,
      } as WecomLinkMessageType;
    }
    case SendContentType.MINI_PROGRAM: {
      const send_data = data.send_data as WecomMiniProgramSendData;
      return {
        ...baseMessage,
        msgtype: WecomMsgType.MINI_PROGRAM,
        title: send_data.title,
        desc: send_data.desc,
        headimg: send_data.thumburl,
        appid: send_data.appid,
        cover_image_aeskey: send_data.cover_file_aeskey,
        cover_image_id: send_data.cover_file_id,
        cover_image_md5: send_data.cover_file_md5,
        cover_image_size: send_data.cover_file_size,
        username: send_data.username,
      } as WecomMiniProgramMessageType;
    }
    case SendContentType.FILE: {
      const send_data = data.send_data as WecomFileSendData;
      return {
        ...baseMessage,
        msgtype: WecomMsgType.WECOM_FILE,
        file_url: send_data?.path,
        file_name: send_data?.file_name,
      } as WecomFileMessageType;
    }
  }
};
